import { InputAutocomplete } from '@innovyze/stylovyze';
import React from 'react';
import { User } from '@Types/user.types';
import { roles } from '../NewUserForm/NewUserForm';
import { useCreateUserContext } from '../../contexts/CreateUserContext';
import { useFormikContext } from 'formik';
import { useGlobalization } from '@Translations/useGlobalization';

export default function UserRoleField() {
	const formik = useFormikContext<User>();
	const blocked = !!formik.values?.blocked;

	const { t } = useGlobalization();
	const { setFieldValue, setFieldTouched } = formik;
	const { userErrors } = useCreateUserContext();
	return (
		<InputAutocomplete
			dataCy="roleField"
			options={roles.map(el => ({ key: el, value: el }))}
			onChange={(_e, newElement) => {
				setFieldValue('role', newElement?.key || '');
				setFieldTouched('role', true);
			}}
			onClear={() => {
				setFieldValue('role', '');
			}}
			fieldAttrs={{
				name: 'role',
			}}
			autocompleteProps={{
				onBlur: () => {
					setFieldTouched('role', true);
				},
				disabled: blocked,
			}}
			label={t('Role')}
			error={!!userErrors.role}
			helperText={userErrors.role}
		/>
	);
}
